import React from "react";
import { NavLink } from 'react-router-dom';

import { FaFacebook, FaInstagram, FaYoutube } from "react-icons/fa"

import partnerBob from '../../images/partner/BOB-Security.png'
import partnerJazz from '../../images/partner/JazzCafeLuebeck.png'
import partnerObject from '../../images/partner/Objekt-X-Design.png'
import partnerProSpeed from '../../images/partner/ProSpeedRope.png'
import partnerRiders from '../../images/partner/RidersCafe.png'

import './Footer.css';


const Footer = function (props) {
    return (
        <React.Fragment>
            <div className="footer-container">
                <footer className="footer-body-top"></footer>
                <footer className="footer-body">


                    <div className="footer-body-empty"></div>
                    {/* <div className="footer-flex-container">
                        <div className="footer-flex-container-partner-header">Partner</div>
                        <div className="footer-flex-container-partner">
                            <a href="https://bob-security.com/" target="_blank" rel="noreferrer">
                                <img src={partnerBob} alt="Bob-Security" className="footer-flex-container-partner-img"></img>
                            </a>
                        </div>
                        <div className="footer-flex-container-partner">
                            <img src={partnerJazz} alt="JazzCafeLuebeck" className="footer-flex-container-partner-img"></img>
                        </div>
                        <div className="footer-flex-container-partner">
                            <img src={partnerObject} alt="Objekt-X-Design" className="footer-flex-container-partner-img"></img>
                        </div>
                        <div className="footer-flex-container-partner">
                            <img src={partnerProSpeed} alt="ProSpeedRope" className="footer-flex-container-partner-img"></img>
                        </div>
                        <div className="footer-flex-container-partner">
                            <img src={partnerRiders} alt="Riders Cafe" className="footer-flex-container-partner-img"></img>
                        </div>

                    </div> */}

                    <div className="footer-flex-container">
                        <div className="footer-flex-container-links">
                            <ul className="footer-nav-links">
                                <li>
                                    <NavLink to="/" exact="true">Verein</NavLink>
                                </li>
                                {/* <li>
                                    <NavLink to="/blog" exact="true">Blog</NavLink>
                                </li> */}
                                <li>
                                    <NavLink to="/documents" exact="true">Dokumente</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/faq" exact="true">FAQ</NavLink>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-flex-container-social">
                            <h2> Social Media</h2>
                            <ul className="footer-social-links">
                                <li>
                                    <a href="https://www.instagram.com/combatsports_hl/" target="_blank" rel="noreferrer"><FaInstagram className="icon-link-footer" /></a>
                                </li>
                                <li>
                                    <a href="https://de-de.facebook.com/combat.sports.luebeck/" target="_blank" rel="noreferrer"><FaFacebook className="icon-link-footer" /></a>
                                </li>
                                <li>
                                    <a href="https://www.youtube.com/c/CombatsportsDeHL" target="_blank" rel="noreferrer"><FaYoutube className="icon-link-footer" /></a>
                                </li>
                            </ul>
                        </div>
                        <div className="footer-flex-container-footer">
                            <ul className="footer-nav-links-small">
                                <li>
                                    <NavLink to="/impressum" exact="true">Impressum</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/disclaimer" exact="true">Disclaimer</NavLink>
                                </li>

                            </ul>
                        </div>
                    </div>

                </footer>
            </div>




        </React.Fragment>

    );
}

export default Footer;